<template src="./rating-stars-field.html"></template>

<script lang="ts">
import domUtils from 'util/dom-utils'
import FieldGroup from 'objects/form/FieldGroup.vue'
import fieldGroupPropsMixin from 'objects/form/FieldGroupPropsMixin.vue'


export default {
  data() {
    return {
      hoverRating: 0,
      starRefs: []
    }
  },
  props: {
    describedbyId: {
      type: String,
      default: () => `tt-hint-${Math.random().toString(16).slice(5)}`
    },
    modelValue: { // rating, set via v-model
      type: Number,
      default: 0
    },
    starSize: {
      type: String,
      default: 'xxl'
    }
  },
  emits: ['update:modelValue'],
  components: {
    'tt-field-group': FieldGroup
  },
  mixins: [fieldGroupPropsMixin],
  computed: {
    rating() {
      return this.hoverRating || this.modelValue
    }
  },
  methods: {
    ratingSelected(e, rating) {
      if (e.type !== 'keydown') {
        this.$emit('update:modelValue', rating)
        return
      }
      let newRating = 0
      if ([38, 39].indexOf(e.keyCode) > -1) {
        newRating = rating === 5 ? 1 : rating + 1
        domUtils.safeFocus(this.starRefs[newRating - 1])
      } else if ([37, 40].indexOf(e.keyCode) > -1) {
        newRating = rating === 1 ? 5 : rating - 1
        domUtils.safeFocus(() => this.starRefs[newRating - 1])
      } else if (rating === 1 && e.keyCode === 32) {
        newRating = 1
      }
      if (newRating > 0) {
        e.preventDefault()
        this.$emit('update:modelValue', newRating)
      }
      return false
    },
    ratingEnter(rating) {
      this.hoverRating = rating
    },
    ratingLeave() {
      this.hoverRating = 0
    },
    setStarRef(el) {
      if (el) {
        this.starRefs.push(el)
      }
    }
  },
  beforeUpdate() {
    this.starRefs = []
  }
}
</script>

<style lang="scss" src="./rating-stars.scss"></style>
